export class CentralStationContactConditionsDto {
    Name: string;
    DateOfBirth: string;
    ContactNumber: number;
    AllergyConditionsCount: string;
    MedicalConditionsCount: string;
}